import { world } from '../../languages';
import { AVAILABLE_WORLDS } from '../../languages/constants';
import serializeQueryParams from '../url/serialize-query-params';

const searchStateToElasticParams = (searchState: SearchState): ElasticServiceParams => ({
    author: searchState.author.toString(),
    auto_suggest: searchState.pas ? 0 : 1,
    c: searchState.c.toString(),
    f: searchState.f.toString(),
    ft: searchState.ft.toString(),
    limit: searchState.limit,
    lng: searchState.lng.toString(),
    ly: searchState.ly.toString(),
    mt: searchState.mt.toString(),
    ob: searchState.ob.toString(),
    p: searchState.p,
    prc: searchState.prc.toString(),
    q: searchState.query || '',
    s: searchState.s,
    sale: searchState.sale.toString(),
    st: searchState.st.toString(),
    t: searchState.t,
    test_segment: Number(serializeQueryParams().test_segment) || (world === AVAILABLE_WORLDS.DE ? 27 : 7),
    tg: searchState.tg.toString(),
    tp: searchState.tp.toString()
});

export default searchStateToElasticParams;
